import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { ValidatedTextInput } from '@els/els-react--text-input';
import { ProfileSettingsConfig } from '@Constants/rx-user/constants';
import CheckRadio from '@Pages/ProfileSettings/Preferences/components/CheckRadio';
import ProfileSettingsAccordionItem from '@Pages/ProfileSettings/Components/ProfileSettingsAccordionItem';
import { NUMERIC_PREFERENCE_ERROR, JAVA_INTEGER_MAX, isValidNumericPreference, validateNumericPreference } from './RxEditorValidation';

import './RxEditor.scss';

const INPUTS = [
  {
    key: 'RX2_ATOMS_NUMBER',
    id: 'atomsNumber',
    name: 'atomsNumber',
    label: ProfileSettingsConfig.Labels.numberOfAtoms,
  },
  {
    key: 'RX2_FRAGMENTS_NUMBER',
    id: 'fragmentsNumber',
    name: 'fragmentsNumber',
    label: ProfileSettingsConfig.Labels.numberOfFragmens,
  },
  {
    key: 'RX2_RING_CLOSURES_NUMBER',
    id: 'closuresNumber',
    name: 'closuresNumber',
    label: ProfileSettingsConfig.Labels.numberOfRingClosures,
  },
];

function RxEditor({ editorPreferencesTitles, optionGroups, currentOptions, currentInputs, onChange, onSave, onClose }) {
  const handleOptionChange = (name, value) => onChange(`RX2_OPTIONS.${name}`, value);
  const handleInputChange = (input, value) => {
    onChange(input.key, value);
  };

  const renderValue = () => editorPreferencesTitles.map((title) => ({ title: '', value: title }));
  const formValid = INPUTS.every((input) => isValidNumericPreference(currentInputs[input.key]));
  const handleSave = (closeCallback) => {
    if (formValid) onSave(closeCallback);
  };

  return (
    <ProfileSettingsAccordionItem
      onClose={onClose}
      onSave={handleSave}
      label={ProfileSettingsConfig.Labels.preferences}
      dataE2E="profile-settings-accordion-row-preferences"
      value={renderValue()}
      validateOnSave
      formValid={formValid}
      className="rx-editor-accordion-item">
      <>
        {optionGroups.map((optionGroup) => (
          <div key={`${optionGroup.title}-${optionGroup.options?.length}`} className="rx-editor-accordion-item__options">
            {!!optionGroup.title && <div className="rx-editor-accordion-item__options_title">{optionGroup.title}</div>}
            <div className="rx-editor-accordion-item__options_list">
              {optionGroup.options?.map((option) => (
                <CheckRadio
                  key={option.id}
                  option={option}
                  value={currentOptions[option.property]}
                  onChange={(value) => handleOptionChange(option.property, value)}
                />
              ))}
            </div>
          </div>
        ))}
        {INPUTS.map((input) => (
          <ValidatedTextInput
            data-e2e={`rx-editor-input-${input.key}`}
            key={input.key}
            id={input.id}
            className="u-els-margin-top-1o2"
            name={input.name}
            label={input.label}
            value={currentInputs[input.key] ?? ''}
            isNumberInput
            max={JAVA_INTEGER_MAX}
            step={1}
            validator={validateNumericPreference}
            messages={{ ERROR: NUMERIC_PREFERENCE_ERROR }}
            onChange={(event) => handleInputChange(input, event.target?.value)}
          />
        ))}
      </>
    </ProfileSettingsAccordionItem>
  );
}

RxEditor.propTypes = {
  editorPreferencesTitles: PropTypes.array,
  optionGroups: PropTypes.array,
  currentOptions: PropTypes.object,
  currentInputs: PropTypes.object,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
};

RxEditor.defaultProps = {
  optionGroups: [],
  editorPreferencesTitles: [],
  currentInputs: {},
  currentOptions: {},
  onChange: noop,
  onSave: noop,
  onClose: noop,
};
export default RxEditor;
